import { Directive, inject } from '@angular/core';
import { MatTab } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';

@Directive({
	selector: 'mat-tab[routerLink]',
	standalone: true
})
export class RouterTabDirective {


	public tab = inject(MatTab);
	public link = inject(RouterLink);

}